import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AccountOverview = ({ partnerData, userProfile }) => {
  const accountStats = [
    {
      label: 'Account Status',
      value: partnerData?.status?.replace('_', ' ')?.toUpperCase() || 'N/A',
      icon: 'UserCheck',
      color: partnerData?.status === 'active' ? 'success' : 'warning'
    },
    {
      label: 'Member Since',
      value: partnerData?.created_at ? new Date(partnerData.created_at)?.toLocaleDateString() : 'N/A',
      icon: 'Calendar',
      color: 'primary'
    },
    {
      label: 'Compliance Status',
      value: partnerData?.compliance_verified ? 'Verified' : 'Pending',
      icon: 'Shield',
      color: partnerData?.compliance_verified ? 'success' : 'warning'
    },
    {
      label: 'Partner Type',
      value: partnerData?.partner_type?.toUpperCase() || 'TRAVEL',
      icon: 'Building2',
      color: 'secondary'
    }
  ];

  const getColorClass = (color) => {
    switch (color) {
      case 'success': return 'text-success bg-success/10 border-success/20';
      case 'warning': return 'text-warning bg-warning/10 border-warning/20';
      case 'primary': return 'text-primary bg-primary/10 border-primary/20';
      case 'secondary': return 'text-secondary bg-secondary/10 border-secondary/20';
      default: return 'text-muted-foreground bg-muted/10 border-muted/20';
    }
  };

  return (
    <div className="glass-container rounded-xl border border-border/50 p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-16 h-16 rounded-full bg-primary/10 border-2 border-primary/20 flex items-center justify-center">
            <Icon name="User" size={32} className="text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-foreground">
              {userProfile?.full_name || 'Partner Account'}
            </h2>
            <p className="text-sm text-muted-foreground">
              {userProfile?.email || 'No email provided'}
            </p>
          </div>
        </div>
        <Button variant="outline" iconName="Edit" size="sm">
          Edit Profile
        </Button>
      </div>
      {/* Account Stats Grid */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        {accountStats?.map((stat, index) => (
          <div
            key={index}
            className="p-4 rounded-lg border border-border/50 hover:bg-accent/5 transition-colors"
          >
            <div className="flex items-center space-x-3 mb-2">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center border ${getColorClass(stat?.color)}`}>
                <Icon name={stat?.icon} size={16} />
              </div>
              <span className="text-sm text-muted-foreground">{stat?.label}</span>
            </div>
            <p className="text-lg font-semibold text-foreground capitalize">{stat?.value}</p>
          </div>
        ))}
      </div>
      {/* Contact Information */}
      <div className="border-t border-border/50 pt-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Contact Information</h3>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <Icon name="Mail" size={18} className="text-muted-foreground" />
            <span className="text-sm text-foreground">{userProfile?.email || 'Not provided'}</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="Phone" size={18} className="text-muted-foreground" />
            <span className="text-sm text-foreground">{partnerData?.contact_phone || 'Not provided'}</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="MapPin" size={18} className="text-muted-foreground" />
            <span className="text-sm text-foreground">{partnerData?.business_address || 'Not provided'}</span>
          </div>
        </div>
      </div>
      {/* Quick Actions */}
      <div className="border-t border-border/50 pt-6 mt-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
        <div className="grid grid-cols-2 gap-3">
          <Button variant="outline" iconName="FileText" size="sm" fullWidth>
            View Contract
          </Button>
          <Button variant="outline" iconName="Download" size="sm" fullWidth>
            Download Reports
          </Button>
          <Button variant="outline" iconName="MessageSquare" size="sm" fullWidth>
            Contact Support
          </Button>
          <Button variant="outline" iconName="HelpCircle" size="sm" fullWidth>
            Help Center
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountOverview;